import convert from 'color-convert';
import {createGrouper} from './basic';
export default createGrouper((r, g, b)=>{
    return convert.rgb.hsv(r, g, b)[0];
  },
  (base, r,g,b) =>{
    let hsv = convert.rgb.hsv(r,g,b);
    let ratio = Math.abs(180 - (hsv[0] - base + 360) % 360) / 180;
    return convert.hsv.rgb(hsv[0], Math.floor(hsv[1] * ratio), hsv[2]);
})
